import { render } from "./StudentMaster.vue?vue&type=template&id=a3830fda&scoped=true"
import script from "./StudentMaster.vue?vue&type=script&lang=js"
export * from "./StudentMaster.vue?vue&type=script&lang=js"

import "./StudentMaster.vue?vue&type=style&index=0&id=a3830fda&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3830fda"]])

export default __exports__